var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 7.40625C9.9375 7.46875 9.84375 9.3125 11.875 10.2812C11.5 11.4375 10.1875 14 8.65625 14C7.78125 14 7.28125 13.4375 6.28125 13.4375C5.25 13.4375 4.6875 14 3.90625 14C2.40625 14.0625 0.96875 11.25 0.5625 10.0938C0.25 9.21875 0.125 8.375 0.125 7.5625C0.125 4.78125 1.96875 3.4375 3.71875 3.40625C4.5625 3.40625 5.625 4 6.09375 4C6.53125 4 7.75 3.28125 8.875 3.375C10.0312 3.46875 10.9062 3.90625 11.5 4.75C10.4688 5.40625 9.9375 6.25 9.9375 7.40625ZM8.1875 2.28125C7.5625 3 6.8125 3.40625 6 3.34375C5.9375 2.5 6.25 1.71875 6.8125 1.09375C7.3125 0.53125 8.1875 0.0625 8.9375 0C8.9375 0.34375 9.03125 1.28125 8.1875 2.28125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3cde69a326d751ef15216c844104da6a.svg";
export { ForwardRef as ReactComponent };